import React, { useState } from 'react';
import DocumentPreview from '../../utils/DocumentPreview';
import AuthorReferenceModal from './AuthorReferenceModal'; // You'll need to create this

const ReferencesComponent = ({ references }) => {
  // Document preview states
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewDocId, setPreviewDocId] = useState(null);
  const [previewDocumentName, setPreviewDocumentName] = useState(null);

  // Author reference modal states
  const [authorModalOpen, setAuthorModalOpen] = useState(false);
  const [selectedAuthorRef, setSelectedAuthorRef] = useState(null);

  // Handle document preview
  const handlePreviewDocument = (docId, documentName) => {
    setPreviewDocId(docId);
    setPreviewDocumentName(documentName);
    setPreviewOpen(true);
  };

  // Close document preview
  const closePreview = () => {
    setPreviewOpen(false);
    setPreviewDocId(null);
    setPreviewDocumentName(null);
  };

  // Handle author reference view
  const handleViewAuthorReference = (authorRef) => {
    setSelectedAuthorRef(authorRef);
    setAuthorModalOpen(true);
  };

  // Close author reference modal
  const closeAuthorModal = () => {
    setAuthorModalOpen(false);
    setSelectedAuthorRef(null);
  };

  // Get author display name
  const getAuthorDisplay = (authorRef) => {
    const authors = Array.isArray(authorRef?.authors) ? authorRef.authors : [];
    if (authors.length === 0) {
      return `Anonymous ${authorRef?.ar_id || ''}`.trim();
    }
    return authors.length === 1 ? authors[0] : `${authors[0]} et al.`;
  };

  if (!references) {
    return null;
  }

  // Handle both old array format and new nested format
  const docIds = Array.isArray(references?.doc_ids)
    ? references.doc_ids
    : (Array.isArray(references) ? references : []);
  const arIds = Array.isArray(references?.ar_ids) ? references.ar_ids : [];

  // If no references at all
  if (docIds.length === 0 && arIds.length === 0) {
    return null;
  }

  return (
    <>
      <div className="ev-card-8 ev-radius-small">
        <h6 className="ev-reg-p-blue">
          <i className="bi bi-file-text"></i> References
        </h6>

        {/* Document References Section */}
        {docIds.length > 0 && (
          <div className="mb-2">
            <p className="ev-small-p-blue mb-1 fw-bold">Documents:</p>
            <div>
              {docIds.map((ref, index) => {
                const documentName = ref?.doc_name || ref?.document_name || `Document ${ref?.doc_id || index + 1}`;
                return (
                  <span
                    key={`doc-${index}`}
                    className="badge bg-primary ev-fs-11 ev-btn-small pe-1 me-1 mb-2"
                    data-tooltip={documentName}
                  >
                    <span>
                      {documentName.length > 15
                        ? documentName.substring(0, 15) + '...'
                        : documentName}
                      &nbsp;
                    </span>
                    <button
                      type="button"
                      onClick={() => handlePreviewDocument(ref?.doc_id, documentName)}
                      className="ms-2 ev-btn-white-fill-round ev-btn-xsmall"
                    >
                      View <i className="bi bi-eye"></i>
                    </button>
                  </span>
                );
              })}
            </div>
          </div>
        )}

        {/* Author References Section */}
        {arIds.length > 0 && (
          <div>
            <p className="ev-small-p-blue mb-1 fw-bold">Cross References:</p>
            <div>
              {arIds.map((ref, index) => {
                const authorDisplay = getAuthorDisplay(ref);
                return (
                  <span
                    key={`ar-${index}`}
                    className="badge ev-badge-ar ev-fs-11 ev-btn-small pe-1 me-1 mb-2"
                    data-tooltip={ref?.title || authorDisplay}
                  >
                    <span>
                      {authorDisplay.length > 15
                        ? authorDisplay.substring(0, 15) + '...'
                        : authorDisplay}
                      &nbsp;
                    </span>
                    <button
                      type="button"
                      onClick={() => handleViewAuthorReference(ref)}
                      className="ms-2 ev-btn-white-fill-round ev-btn-xsmall"
                    >
                      View <i className="bi bi-eye"></i>
                    </button>
                  </span>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Document Preview Modal */}
      <DocumentPreview
        isOpen={previewOpen}
        onClose={closePreview}
        docId={previewDocId}
        documentName={previewDocumentName}
      />

      {/* Author Reference Modal */}
      <AuthorReferenceModal
        isOpen={authorModalOpen}
        onClose={closeAuthorModal}
        authorRef={selectedAuthorRef}
      />
    </>
  );
};

export default ReferencesComponent;
